import { render, staticRenderFns } from "./ModalCheckItemSafety.vue?vue&type=template&id=4fecef0b&scoped=true&"
import script from "./ModalCheckItemSafety.vue?vue&type=script&lang=js&"
export * from "./ModalCheckItemSafety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fecef0b",
  null
  
)

export default component.exports